<template>
	<Hero :collections="collections"/>

	<section class="block-lg">
		<div class="hp-card-list">
<!--			<HpBlockList-->
<!--				:title="`Mock feedback`"-->
<!--				:cards="fakeFeedbacks"-->
<!--			/>-->
<!--			<HpBlockList-->
<!--				:title="`Mock Complaints`"-->
<!--				:cards="fakeComplaints"-->
<!--			/>-->
<!--			<HpBlockList-->
<!--				:title="`Mock Events`"-->
<!--				:cards="fakeEvents"-->
<!--			/>-->
			<HpBlockList
				:title="$t('events')"
				:cards="events"
                :loading="isLoadingEvents"
			/>
<!--			<HpBlockList-->
<!--				:title="`Mock Collections`"-->
<!--				:cards="fakeCollections"-->
<!--			/>-->
			<HpBlockList
				:title="$t('nftCollections')"
				:cards="collections"
                :loading="isLoadingCollections"
			/>
		</div>
	</section>

	<OurMission/>
	<AllInOne/>
</template>

<script>
import {useApi} from '~/composables/api';
// import feedbacks from '@/mock/feedbacks.json'
// import complaints from '@/mock/complaints.json'
// import events from '@/mock/events.json'
// import collections from '@/mock/collections.json'

export default {
	name: 'nft',
	setup() {
		definePageMeta({
			middleware: ['entities'],
		})

		const { $config } = useNuxtApp();

        useSeoMeta({
            title: `DOXXY`,
            ogTitle: `DOXXY`,
            description: 'NFT Events',
            ogDescription: 'NFT Events',
			ogImage: $config.public.OG_DEFAULT_IMAGE,
        });

		const arrAlternatives = [];

		for (const lang in $config.public.ALTERNATIVES) {
			arrAlternatives.push({
				rel: 'alternate',
				hreflang: lang,
				href: $config.public.ALTERNATIVES[lang]
			})
		}
		arrAlternatives.push({
			rel: 'alternate',
			hreflang: 'x-default',
			href: $config.public.ALTERNATIVES['en']
		})

		useHead({
			link: arrAlternatives
		})
	},
	data() {
		return {
            isLoadingEvents: true,
            isLoadingCollections: true,
			events: [],
			collections: []
		}
	},
	// computed: {
	// 	fakeFeedbacks() {
	// 		return feedbacks
	// 	},
	// 	fakeComplaints() {
	// 		return complaints
	// 	},
	// 	fakeEvents() {
	// 		return events
	// 	},
	// 	fakeCollections() {
	// 		return collections
	// 	}
	// },
	mounted() {
		this.fetchRecentEvents();
		this.fetchRecentCollections();
	},
	methods: {
		async fetchRecentEvents() {
			try {
                this.isLoadingEvents = true;

                const api = useApi();
				const response = await api.events.fetchRecentEvents();

				if (response) {
					this.events = response.results.map(item => {
						const obj = {...item};

						if (obj.updated) {
							obj.detailBadges = [
								{
									text: 'Updated',
									iconClass: 'icon-refresh',
									bgClass: 'bg-orange-2'
								}
							]
						} else {
							obj.detailBadges = [
								{
									text: 'Listed',
									iconClass: 'icon-resolved',
									bgClass: 'bg-green'
								}
							]
						}

						return obj;
					});
				}
			} catch (e) {
				console.error(e)
			} finally {
                this.isLoadingEvents = false;
			}
		},
		async fetchRecentCollections() {
			try {
                this.isLoadingCollections = true;

                const api = useApi();
				const response = await api.collections.fetchRecentCollections();

				if (response?.results?.length) {
					this.collections = response.results.map(item => {
						const obj = {...item};

						if (obj.updated) {
							obj.detailBadges = [
								{
									text: 'Updated',
									iconClass: 'icon-refresh',
									bgClass: 'bg-orange-2'
								}
							]
						} else {
							obj.detailBadges = [
								{
									text: 'Listed',
									iconClass: 'icon-resolved',
									bgClass: 'bg-green'
								}
							]
						}

						return obj;
					});
				}
			} catch (e) {
				console.error(e)
			} finally {
                this.isLoadingCollections = false;
			}
		},
	},
}
</script>


